import { useState, useEffect } from "react";

export default function CountdownTimer() {
  const defaultDeadline = "2025-05-21T00:00";
  const [deadline, setDeadline] = useState(defaultDeadline);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isTimeUp, setIsTimeUp] = useState(false); // New state to track if time is up

  useEffect(() => {
    if (!deadline) return;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const targetTime = new Date(deadline).getTime();
      const difference = targetTime - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
        setIsTimeUp(false); // Ensure the message is hidden while counting down
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setIsTimeUp(true); // Set time-up state to true
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [deadline]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white p-4">
      <h1 className="text-3xl font-bold mb-4">Countdown 🎓</h1>
      <div className="mt-6 text-4xl font-bold">
        {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
      </div>
      {isTimeUp && (
        <div className="mt-12 text-center text-4xl font-bold text-red-500">
          <p>Dear everyone,</p>
          <p className="mt-4">
            It brings me great sadness to inform you that your favorite small talk subject will need to be laid to rest.<br />
            Let's fondly remember the great laughs we shared, talking about the same subject over and over again.
          </p>
          <p className="mt-4">
            Thanks for visiting my stupid site and being annoying/supporting me along the way.<br />
            Lord knows, I would not have bothered without you.
          </p>
          <p className="mt-6 text-2xl">❤️</p>
        </div>
      )}
    </div>
  );
}

